import { CONSTANTS_GENERATION__value_default } from '@shared/constants/CONSTANTS_GENERATION__value_default';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__token } from '../DTO__token';

export function try_add_token_to_array_of_tokens_with_word_english(
  array: DTO__token[],
  word_english: string,
  is_positive: boolean,
  create_word_object: boolean,
  weight: number = CONSTANTS_GENERATION__value_default.TOKEN_WEIGHT,
): DTO__token[] {
  let out = [...array];

  let token_existing = out.find(token => token.word_english == word_english);

  if (token_existing) {
    //token already exists, just enable it
    out = out.map(token => (token.word_english == token_existing.word_english ? token_existing.clone({ is_hidden: false }) : token));
  } else {
    let token = new DTO__token();
    token.word_english = word_english;
    token.is_positive = is_positive;
    token.is_hidden = false;
    token.weight = weight;

    //on server we dont create word object and dont store it in database, only word_english
    if (create_word_object) {
      let word = new DTO__word();

      [word.word_english, word.word_translated, token.word] = [word_english, word_english, word];
    }

    out.push(token);
  }

  return out;
}
